import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { retrieveErrorMessage } from '@common';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GAEvent } from '../../models/ga-event.enum';
import { GAHttpErrorConstructor } from '../../models/ga-http-error-constructor.type';
import { GAService } from '../../services/ga.service';
import { GA_CONFIG } from '../../tokens/ga-config.token';

export const gaHttpErrorInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const gaConfig = inject(GA_CONFIG);
  const gaService = inject(GAService);

  return next(request).pipe(
    tap({
      error: (error: HttpErrorResponse) => {
        const parser = document.createElement('a');
        parser.href = request.url;
        const requestPath = parser.pathname;
        const gaHttpErrorConstructor: GAHttpErrorConstructor | undefined =
          gaConfig.httpErrorMapping[requestPath];

        return gaHttpErrorConstructor
          ? gaService.tag(gaHttpErrorConstructor(request, error))
          : gaService.tag({
              event: GAEvent.GenericError,
              errorCode: error.status,
              errorMessage: retrieveErrorMessage(error),
              url: request.url,
            });
      },
    }),
  );
};
